import React from 'react';
import { RestockDateTemplate } from 'themes/modules/restock-date';
import { RestockDateViewStore } from 'modules/restock-date/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new RestockDateViewStore(rootStore, componentProps),
	'restockDateViewStore'
)
class RestockDate extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <RestockDateTemplate {...this.props} viewStore={this.props.restockDateViewStore} />;
	}
}

export default RestockDate;



// WEBPACK FOOTER //
// ./src/modules/restock-date/pages/RestockDate.jsx